import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  avatarWrapper: {
    width: 68,
    height: 68,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      width: 44,
      height: 44
    }
  },
  moreThanFourMembersWrapper: {
    width: 68,
    height: 68,
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    justifyContent: 'center',
    alignContent: 'center',
    [theme.breakpoints.down('xs')]: {
      width: 44,
      height: 44
    }
  },
  oneMember: {
    width: 68,
    height: 68,
    textTransform: 'uppercase',
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      width: 44,
      height: 44
    }
  },
  twoMembers: {
    width: 44,
    height: 44,
    textTransform: 'uppercase',
    fontSize: 16,
    fontWeight: 500,
    position: 'absolute',
    '&:nth-child(1)': {
      right: 0
    },
    '&:nth-child(2)': {
      bottom: 0
    },
    [theme.breakpoints.down('xs')]: {
      width: 30,
      height: 30,
      fontSize: 10,
      '&:nth-child(1)': {
        right: 0
      },
      '&:nth-child(2)': {
        bottom: 0
      }
    }
  },
  threeMembers: {
    width: 32,
    height: 32,
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 500,
    zIndex: 1,
    position: 'absolute',
    '&:nth-child(1)': {
      zIndex: 2,
      right: 18,
      top: 8
    },
    '&:nth-child(2)': {
      zIndex: 1,
      bottom: 6,
      left: 6
    },
    '&:nth-child(3)': {
      zIndex: 0,
      bottom: 6,
      right: 6
    },
    [theme.breakpoints.down('xs')]: {
      width: 24,
      height: 24,
      fontSize: 8,
      '&:nth-child(1)': {
        zIndex: 2,
        right: 10,
        top: 0
      },
      '&:nth-child(2)': {
        zIndex: 1,
        bottom: 3,
        left: 0
      },
      '&:nth-child(3)': {
        zIndex: 0,
        bottom: 3,
        right: 0
      }
    }
  },
  moreThanFourMembers: {
    width: 32,
    height: 32,
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 500,
    [theme.breakpoints.down('xs')]: {
      width: 20,
      height: 20,
      fontSize: 8
    }
  },
  personIcon: {
    width: 20,
    height: 20,
    [theme.breakpoints.down('xs')]: {
      width: 13.33,
      height: 13.33
    }
  },
  onePersonIcon: {
    width: 40,
    height: 40,
    [theme.breakpoints.down('xs')]: {
      width: 20,
      height: 20
    }
  },
  twoPersonIcon: {
    width: 24,
    height: 24,
    [theme.breakpoints.down('xs')]: {
      width: 15,
      height: 15
    }
  }
}));
